export const PATIENT_RECORD_OVERRIDES = {} as any;
